import { useLocalizedHref } from "@libraries/web-framework";
import { useIntl } from "react-intl";

import FeatureGates from "@atlassian/feature-gate-js-client";
import UFOSegment from "@atlassian/wac-ufo-segment";

import BannerAlert, {
    BannerProps
} from "@/components/wpl/banner-alert/src/index";
import GlobalFooterPattern from "@/patterns/global-footer/src/index";
import GlobalNavigation from "@/patterns/global-nav/src/index";

import {
    Hero,
    Carousel,
    SocialProof,
    Cards,
    Careers,
    LiftedBanner
} from "./sections";

export const HomePageTemplate = () => {
    const intl = useIntl();
    const gate: boolean = FeatureGates.checkGate("gwp-745-unleash-butter-bar");
    const showWebinarAnnouncementBannerJa: boolean = FeatureGates.checkGate(
        "gwp-922-ja-fy24-jan-webinar-announcement"
    );

    const serverBannerMessages = {
        identifier: "HomePage.banner-alert.server-support-end",
        text: intl.formatMessage({
            id: "HomePage.banner-alert.text",
            defaultMessage:
                "Support for Server products ends Feb. 15, 2024. Migrate to stay supported."
        }),
        linkText: intl.formatMessage({
            id: "HomePage.banner-alert.link-text",
            defaultMessage: "Act now"
        }),
        linkUrl: useLocalizedHref("/migration/assess/journey-to-cloud")
    };

    const unleashBannerMessages = {
        identifier: "HomePage.banner-alert.atlassian-presents-unleash",
        text: intl.formatMessage({
            id: "HomePage.banner-alert.atlassian-presents-unleash",
            defaultMessage:
                "Watch Atlassian Presents: Unleash on demand! Get tips for managing complexity at scale and staying in the flow."
        }),
        linkText: intl.formatMessage({
            id: "HomePage.banner-alert.atlassian-presents-unleash.link-text",
            defaultMessage: "Watch now"
        }),
        linkUrl:
            "https://events.atlassian.com/unleash/in-person?ref=Unleash&utm_source=marketing&utm_campaign=acquisitionwebliftedbar&utm_medium=web"
    };

    const webinarBannerMessagesJa: BannerProps = {
        identifier:
            "jira-software.banner-alert.gwp-922-ja-fy24-jan-webinar-announcement",
        text: "ウェビナー開催: 生成 AI の今が分かる！バーチャルチームメイトでデジタルビジネスを加速",
        linkText: intl.formatMessage({
            id: "jira-software.banner-alert.link-text.ja",
            defaultMessage: "登録はこちら >"
        }),
        linkUrl:
            "/ja/webinars/international/ja-accelerate-business-with-generative-ai?utm_bmcr_source=referral-internal_butter-banner_&utm_source=butter-banner&utm_medium=referral-internal&utm_campaign=P:multiproduct*O:japan*C:webinar*V:butter-banner*H:fy24q3*I:japan-jan-webinar",
        dataEventProps: {
            "data-product-key": "jiraSoftware",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "登録はこちら >",
            "data-label-english": "Register here"
        }
    };

    return (
        <UFOSegment name="home-page">
            <div>
                <GlobalNavigation showTryNow={true} productKey={"home"} />
                {intl.locale === "ja" && showWebinarAnnouncementBannerJa ? (
                    <BannerAlert {...webinarBannerMessagesJa} />
                ) : gate ? (
                    <BannerAlert
                        identifier={unleashBannerMessages.identifier}
                        text={unleashBannerMessages.text}
                        linkUrl={unleashBannerMessages.linkUrl}
                        linkText={unleashBannerMessages.linkText}
                    />
                ) : (
                    <BannerAlert
                        identifier={serverBannerMessages.identifier}
                        text={serverBannerMessages.text}
                        linkUrl={serverBannerMessages.linkUrl}
                        linkText={serverBannerMessages.linkText}
                    />
                )}

                <Hero />
                <LiftedBanner />
                <Carousel />
                <SocialProof />
                <Cards />
                <Careers />
                <GlobalFooterPattern />
            </div>
        </UFOSegment>
    );
};
